import * as React from 'react';
import { cn } from '../../lib/utils';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link' | 'primary';
  size?: 'default' | 'sm' | 'lg' | 'icon';
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'default', size = 'default', ...props }, ref) => {
    const baseStyles =
      'inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-semibold transition-colors disabled:pointer-events-none disabled:opacity-50';

    const variants = {
      primary: 'bg-accent text-white hover:bg-accent-hover shadow-sm shadow-accent/20',
      default: 'bg-surface text-ink hairline hover:bg-line/40',
      destructive: 'bg-rose-soft text-rose hover:bg-rose/15',
      outline: 'border border-line bg-surface hover:bg-line/40',
      secondary: 'bg-line/60 text-muted hover:bg-line',
      ghost: 'text-muted hover:text-ink hover:bg-line/50',
      link: 'text-accent underline-offset-4 hover:underline',
    };

    const sizes = {
      default: 'h-10 px-4 py-2',
      sm: 'h-9 rounded-md px-3',
      lg: 'h-11 rounded-md px-8',
      icon: 'h-10 w-10',
    };

    return (
      <button
        className={cn(baseStyles, variants[variant], sizes[size], className)}
        ref={ref}
        {...props}
      />
    );
  }
);

Button.displayName = 'Button';

export { Button };
